
/**
 * Checks if plan passed as first argument can be upgraded to the plan passed as
 * the second argument.
 *
 * @param {object} currentPlan              Current plan model.
 * @param {Array}  currentPlan.upgradePlans Slugs of plans available to upgrade
 *                                          from current plan.
 * @param {object} newPlan                  New plan model.
 * @param {string} newPlan.slug             New plan slug.
 * @returns {boolean} If upgrads is possible.
 */
export const canUpgrade = ({ upgradePlans }, { slug }) =>
    upgradePlans.includes(slug);

/**
 * Checks if plan passed as first argument can be downgraded to the plan passed
 * as the second argument.
 *
 * @param {object} currentPlan              Current plan model.
 * @param {Array}  currentPlan.downgradePlans Slugs of plans available to
 *                                          downgrade from current plan.
 * @param {object} newPlan                  New plan model.
 * @param {string} newPlan.slug             New plan slug.
 * @returns {boolean} If upgrads is possible.
 */
export const canDowngrade = ({ downgradePlans }, { slug }) =>
    downgradePlans.includes(slug);

/**
 * Returns filtered array of plans containing only items available to upgrade
 * from the plan given as the first parameter.
 *
 * @param {object} currentPlan              Current plan model.
 * @param {Array}  currentPlan.upgradePlans Slugs of plans available to upgrade
 *                                          from given plan.
 * @param {Array}  plans                    Collection of all plans.
 * @returns {Array} Plans available for upgrade from given plan.
 */
export const getUpgradePlans = ({ upgradePlans }, plans) =>
    plans.filter(({ slug }) => upgradePlans.includes(slug));
